<template>
  <div>
    <div class="gridItem">
      <div class="inputCard">
        <header class="pointer" @click="accordion.shop = !accordion.shop" :style="accordion.shop ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.shop ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Shop</header>
        <div class="content" v-if="accordion.shop">
          <div class="cardRow w3-padding-8">
            <label>Enabled</label>
            <div class="w3-right-align">
              <label class="switch">
                <input type="checkbox" v-model="state.siteData.pages.home.sections.shop.enabled">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="cardRow w3-padding-8">
            <label>Products Type</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.shop.productsType">
              <option value="carousel">Carousel</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require('@/dataStore').default

export default {
  name: 'cmshomeproducts',
  data() {
    return {
      state: dataStore.state
    }
  },
  props: {
    accordion: Object
  },
  methods: {
    toggleAccordion() {
      this.$emit('toggleAccordion', !this.accordion.shop)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cms/pages/home/cmsHomeProducts.vue